import React from 'react';
import {useUserSessionContext} from '../../core/UserSessionContext';
import {Format} from '../../../utils';
import styles from './HelloUsername.module.scss';

const HelloUsername = () => {
  const {currentUser} = useUserSessionContext();
  const username = Format.formatUserName(currentUser?.profile?.firstName, currentUser?.profile?.lastName);

  return (
    <div className={styles.username}>
      {username}
    </div>
  );
};

export default HelloUsername;
